(function ($, document, window) {
    'use strict';

    $(function () {
        document.querySelectorAll('.js-add-to-cart').forEach(button => {
            button.addEventListener('click', function () {
                const productName = this.getAttribute('data-product_name');
                const productPrice = this.getAttribute('data-product_price');
                const productSku = this.getAttribute('data-product_sku');
                const quantity = this.getAttribute('data-quantity');

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'add_to_cart',
                    ecommerce: {
                        items: [{
                            item_name: productName,
                            item_id: productSku,
                            price: productPrice,
                            quantity: quantity,
                        }]
                    }
                });
            });
        });
    });
})(jQuery, document, window);
